import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { api } from "../../lib/api";

export default function Inquiries() {
  const [items, setItems] = useState(null);

  const load = () => api("/admin/inquiries").then(setItems).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const handle = async (id) => {
    try {
      await api(`/admin/inquiries/${id}`, { method: "PATCH", body: { status: "handled" } });
      toast("Marked as handled");
      load();
    } catch (e) { toast.error(e.message); }
  };

  if (!items) return <p className="text-muted font-bold">Checking the mailbag…</p>;

  return (
    <div data-testid="admin-inquiries">
      <h1 className="font-display font-semibold text-2xl">Price inquiries & messages</h1>
      {items.length === 0 ? <p className="text-muted font-semibold mt-6">The mailbag is empty.</p> : (
        <div className="mt-6 space-y-3">
          {items.map((i) => (
            <div key={i.id} className="bg-white rounded-3xl border border-candy-soft/70 p-4" data-testid={`admin-inquiry-${i.id}`}>
              <div className="flex flex-wrap items-center gap-3">
                <p className="font-display font-semibold">{i.name}</p>
                <a href={`mailto:${i.email}`} className="text-sm font-bold text-candy-deep hover:underline">{i.email}</a>
                <span className="text-xs font-bold text-muted">{i.product_title}</span>
                {i.status === "handled" ? (
                  <span className="ml-auto px-3 py-1 rounded-full bg-mint-soft text-emerald-700 text-xs font-bold">Handled</span>
                ) : (
                  <button data-testid={`admin-inquiry-handle-${i.id}`} onClick={() => handle(i.id)} className="ml-auto inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-candy text-white text-xs font-bold hover:bg-candy-deep transition-colors duration-200">
                    <Check className="w-3.5 h-3.5" /> Mark handled
                  </button>
                )}
              </div>
              {i.message && <p className="mt-2 text-sm text-ink/70 font-semibold bg-candy-mist rounded-xl p-3">{i.message}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
